import mixpanel, { Config } from 'mixpanel-browser'

export function initMixpanel(): void {
  const token = window.flatfile?.configService?.get('MIXPANEL_PROJECT_TOKEN') ?? 'NOT_CONFIGURED'
  // we must call mixpanel.init with a non-empty token even if we
  // don't want to use mixpanel. otherwise, mixpanel calls will throw exceptions.

  const mixpanelConfig: Partial<Config> = {
    track_pageview: 'url-with-path',
    // we will opt in after checking for the mixpanel entitlement
    opt_out_tracking_by_default: true,
  }

  const { hostname } = window.location
  if (hostname !== 'localhost') {
    // if we're in a deployed env, we want to proxy through nginx at our domain
    mixpanelConfig.api_host = `https://${hostname}/mp`
  }

  mixpanel.init(token, mixpanelConfig)
}

export { mixpanel }
